import { render, staticRenderFns } from "./TermsViewer.vue?vue&type=template&id=2b82c431&scoped=true"
import script from "./TermsViewer.vue?vue&type=script&lang=ts"
export * from "./TermsViewer.vue?vue&type=script&lang=ts"
import style0 from "./TermsViewer.vue?vue&type=style&index=0&id=2b82c431&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b82c431",
  null
  
)

export default component.exports